module.exports = __webpack_public_path__ + "img/copy-red.723e6983.svg";